import {
  HOME_FETCH_SCHEDULE_BEGIN,
  HOME_FETCH_SCHEDULE_SUCCESS,
  HOME_FETCH_SCHEDULE_FAILURE,
  HOME_FETCH_SCHEDULE_DISMISS_ERROR,
} from './constants';

import axios from 'axios';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchSchedule(scheduleId) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_FETCH_SCHEDULE_BEGIN,
      data: scheduleId
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      axios.get("/api/Schedules/"+scheduleId).then(
        (res) => {
          dispatch({
            type: HOME_FETCH_SCHEDULE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_FETCH_SCHEDULE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchScheduleError(scheduleId) {
  return {
    type: HOME_FETCH_SCHEDULE_DISMISS_ERROR,
    data: scheduleId
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_FETCH_SCHEDULE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchSchedulePending: 
        {
          ...state.fetchSchedulePending,
          [action.data]: true
        },
        fetchScheduleError: 
        {
          ...state.fetchScheduleError,
          [action.data]: null
        }
      };

    case HOME_FETCH_SCHEDULE_SUCCESS:
      // The request is success
      return {
        ...state,
        schedules:
        {
          ...state.schedules,
          [action.data.schedule.id]:action.data.schedule
        },
        fetchSchedulePending: 
        {
          ...state.fetchSchedulePending,
          [action.data.schedule.id]: false
        },
        fetchScheduleError: 
        {
          ...state.fetchScheduleError,
          [action.data.schedule.id]: null
        }
      };

    case HOME_FETCH_SCHEDULE_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchSchedulePending: 
        {
          ...state.fetchSchedulePending,
          [action.data]: false
        },
        fetchScheduleError: 
        {
          ...state.fetchScheduleError,
          [action.data]: action.data.error
        }
        
      };

    case HOME_FETCH_SCHEDULE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchScheduleError: 
        {
          ...state.fetchScheduleError,
          [action.data]: null
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/fetchSchedule.js